import { Component, Input } from '@angular/core';
import {DataTable} from './../../../services/DataTable'

@Component({
    selector: 'datatable-pagination',
    templateUrl: 'pagination.html',
    styleUrls: ['style.css']
})
export class DataTablePagination {
    @Input() dataTable: DataTable;

    inputPage: any = '';

    ngOnInit ()
    {
        if (this.dataTable) {
            this.dataTable.onPageChange = (page: any) => {
                this.inputPage = page;
            }
        }
    }

    setInputPage() {
        this.inputPage *= 1;
        this.inputPage = Math.floor(this.inputPage);
        if (! isFinite(this.inputPage) || this.inputPage < 1) this.inputPage = 1;
        else if (this.inputPage > this.dataTable.pagination.totalPages)
            this.inputPage = this.dataTable.pagination.totalPages;
        this.dataTable.setPage(this.inputPage);
    }
}


@Component({
    selector: 'datatable-config',
    templateUrl: 'top-bar.html'
})
export class DataTableConfig {
    @Input() dataTable: DataTable;
    isAbleToApply:any = null;

    debounceInput(value) {
        if (!this.isAbleToApply) {
            this.startDebounce(value);
        } else {
            clearTimeout(this.isAbleToApply);
            this.startDebounce(value);
        }
    }

    private startDebounce(value) {
        this.isAbleToApply = setTimeout(() => {
            this.dataTable.setFilter({ q: value })
        }, 350)
    }
}


// WEBPACK FOOTER //
// ./src/app/components/common/datatables/datatable.components.ts